define((require) => {
    "use strict";

    var YouTubeWidgetModel = require("shared/ui/experience/widgets/youtubeWidget/YouTubeWidgetModel"),
        Size               = require("shared/util/Size");

    /**
     * @class {YouTubeWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return YouTubeWidgetModel.mixin("YouTubeWidgetModelEditorMixin", {
        /**
         * 1) Resize (both grow or shrink) the widget to fit it inside an experience,
         * 2) reset the rotation of the widget,
         * 3) move the widget back inside the scene boundaries, if needed
         *
         * This method is called when clicking the 'fit to scene' button.
         */
        fitToScene: function(experience) {
            var percentageSize = this._getWidgetSize();

            if (percentageSize === null) {
                return;
            }

            this._setSize(this._getFittedSize(percentageSize), experience);
            this._resetRotation();
            this._setFittedWidgetPosition();
        },

        /**
         * Get the size of the widget.
         *
         * @return {Size} The size of the widget
         */
        _getWidgetSize: function() {
            return Size.from(this.get("width"), this.get("height"));
        },

        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function() {
            return this.get("videoID") ? `YouTube: ${this.get("videoID")}` : "YouTube:";
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/youtubeWidget/YouTubeWidgetModelEditorMixin.js